const IRISAPI_HOST = new URL(import.meta.env.VITE_IRISAPI_HOST)

/**
 * Replaces the host of the imageUrl and stlUrl for airCraft data
 * Image and Stl Urls are saved and served into the iris_gui database as relative paths. Due to environment differences the hostname cannot be appened by the backend; thus we append it on the frontend.
 * @param {TFnData = unknown} data API Response data containing aircraft details
 */
const buildAircraftImageUrl = (data) => {
  if (!Array.isArray(data)) {
    return data
  }
  return data.map((airCraft) => {
    return {
      ...airCraft,
      imageUrl: new URL(airCraft.imageUrl, IRISAPI_HOST).toString(),
      stlUrl: new URL(airCraft.stlUrl, IRISAPI_HOST).toString(),
      //TODO add in thumbnail url once scaled down aircraft thumbnails are created on iris_gui backend
    }
  })
}

export { buildAircraftImageUrl }
